import React, { useEffect, useState } from "react";
import { ShieldCheck, ShieldAlert, ShieldOff } from "lucide-react";
import api from "@/lib/api";

/** Read-only boundary statement, visible to every user so the AI position is never hidden. */
export const AiTrustBadge = ({ className = "" }) => {
  const [p, setP] = useState(null);

  useEffect(() => {
    api.get("/ai/egress-policy").then(({ data }) => setP(data)).catch(() => {});
  }, []);

  if (!p) return null;

  const off = p.ai_egress_mode === "off";
  const Icon = off ? ShieldOff : p.tenant_bound ? ShieldCheck : ShieldAlert;
  const tone = off
    ? "bg-slate-100 text-slate-600"
    : p.tenant_bound
      ? "bg-emerald-50 text-emerald-800"
      : "bg-amber-50 text-amber-800";
  const text = off
    ? "AI switched off — nothing leaves this application"
    : `${p.tenant_bound ? "Tenant-bound AI (your Azure resource)" : "External AI gateway"} · ${p.ai_egress_mode} redaction · every call logged`;

  return (
    <span data-testid="ai-trust-badge" className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-medium ${tone} ${className}`}>
      <Icon size={12} /> {text}
    </span>
  );
};
